import React from 'react';

const MediaTranslationContext = React.createContext(null);

export const Provider = MediaTranslationContext.Provider;
export const Consumer = MediaTranslationContext.Consumer;

export default MediaTranslationContext;
